
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Light/Light.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Light.html');
        
        var script = require('./Light.ts').default;
        module.exports = require('./Light.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    